import { useEffect, useState } from '@wordpress/element';
import { useMetadadosPalavraChave } from './useMetadadosPalavraChave';
import { useMetadadosTituloSeo } from './useMetadadosTituloSeo';
import { useMetadadosAltImagem } from './useMetadadosAltImagem';
import { useMetadadosPermalink } from './useMetadadosPermalink';
import { useMetadadosMetadescricao } from './useMetadadosMetadescricao';
import { useMetadadosSlug } from './useMetadadosSlug';
import { useMetadadosAutor } from './useMetadadosAutor';
import { useMetadadosPreVisualizacao } from './useMetadadosPreVisualizacao';
import { useSelect } from '@wordpress/data';
import { useMetadadosBreadcrumbs } from './useMetadadosBreadcrumbs';

export const useMetadadosNotas = ({ metadados }) => {
  const [notas, setNotas] = useState({
    palavra_chave: { criterios: [], valor: 0 },
    title_seo: { criterios: [], valor: 0 },
    slug: { criterios: [], valor: 0 },
    link_permanente: { criterios: [], valor: 0 },
    meta_descricao: { criterios: [], valor: 0 },
    alt_imagem: { criterios: [], valor: 0 },
    autor: { criterios: [], valor: 0 },
    pre_visualizacao: { criterios: [], valor: 0 },
    breadcrumbs: { criterios: [], valor: 0 },
  });

  const blogData = useSelect(select => select('core').getSite());
  const { title: nomeBlog } = blogData || {};

  const { analisar: analisarPalavraChave } = useMetadadosPalavraChave();
  const { analisar: analisarTituloSeo } = useMetadadosTituloSeo();
  const { analisar: analisaraAltImagem } = useMetadadosAltImagem();
  const { analisar: analisarPermalink } = useMetadadosPermalink();
  const { analisar: analisarMetadescricao } = useMetadadosMetadescricao();
  const { analisar: analisarSlug } = useMetadadosSlug();
  const { analisar: analisarAutor } = useMetadadosAutor();
  const { analisar: analisarPreVisualizacao } = useMetadadosPreVisualizacao();
  const { analisar: analisarBreadcrumbs } = useMetadadosBreadcrumbs();

  useEffect(() => {
    if (!metadados) return;

    const {
      palavra_chave,
      title_seo,
      alt_imagem,
      link_permanente,
      slug,
      meta_descricao,
      autor,
      icone_url,
      thumbnail_url,
      breadcrumbs,
    } = metadados;
    const analisePalavraChave = analisarPalavraChave(palavra_chave);
    const analiseTituloSeo = analisarTituloSeo(title_seo, palavra_chave);
    const analiseAltImagem = analisaraAltImagem(alt_imagem, palavra_chave);
    const analisePermalink = analisarPermalink(link_permanente, palavra_chave, slug?.valor);
    const analiseMetadescricao = analisarMetadescricao(meta_descricao, palavra_chave);
    const analiseSlug = analisarSlug(slug?.valor, palavra_chave);
    const analiseAutor = analisarAutor(autor);
    const analisePreVisualizacao = analisarPreVisualizacao(
      analisePalavraChave.valor,
      icone_url !== null && icone_url !== undefined && icone_url.length > 0 ? 1 : 0,
      thumbnail_url !== null &&
        thumbnail_url !== undefined &&
        thumbnail_url.length > 0 &&
        thumbnail_url !== 'no_value'
        ? 1
        : 0,
      analiseTituloSeo.valor,
      analiseMetadescricao.valor,
      nomeBlog !== null && nomeBlog !== undefined && nomeBlog.length > 0 ? 1 : 0
    );
    const analiseBreadcrumbs = analisarBreadcrumbs(link_permanente, breadcrumbs);

    setNotas(prev => ({
      ...prev,
      palavra_chave: analisePalavraChave,
      title_seo: analiseTituloSeo,
      alt_imagem: analiseAltImagem,
      link_permanente: analisePermalink,
      meta_descricao: analiseMetadescricao,
      slug: analiseSlug,
      autor: analiseAutor,
      pre_visualizacao: analisePreVisualizacao,
      breadcrumbs: analiseBreadcrumbs,
    }));
  }, [metadados]);

  return { notas };
};
